import { render, staticRenderFns } from "./BetaChip.vue?vue&type=template&id=0fffd935&scoped=true"
import script from "./BetaChip.vue?vue&type=script&lang=js"
export * from "./BetaChip.vue?vue&type=script&lang=js"
import style0 from "./BetaChip.vue?vue&type=style&index=0&id=0fffd935&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fffd935",
  null
  
)

export default component.exports